import { AlertLog } from 'src/types/alerts';
import { UUID, DateUTC } from 'src/types/utility';
import { PATIENT_STATUS } from 'src/routes/IndividualDashboard/components/DashboardTab/TrendingOverviewWidget/types';
import { API_STATUS } from 'src/utils/api-constants';

export type GraphTimeData = {
  date: string;
  value: number;
};

export type MainGraphDataPoint = { x: string; y: number };

export enum TIMEFRAME_RANGE {
  DAY = 'day',
  DAYS_3 = '3days',
  WEEK = 'week',
  CUSTOM = 'custom',
}

export type TimeFrame = {
  startTime: DateUTC;
  endTime: DateUTC;
  range: TIMEFRAME_RANGE;
};

type TimeFrameWithRange = {
  range: TIMEFRAME_RANGE;
  startTime?: DateUTC;
  endTime?: DateUTC;
};

type TimeFrameWithStartEnd = {
  startTime: DateUTC;
  endTime: DateUTC;
  range?: TIMEFRAME_RANGE;
};

export type FlexibleTimeFrame = TimeFrameWithRange | TimeFrameWithStartEnd;

export type TrendingOverviewItemData = {
  time: string;
  hr?: number | null;
  rr?: number | null;
  ie?: number | string | null;
  ra?: number | null;
  motion?: number | null;
  anchorLine?: number | null;
  hrAlert?: AlertLog[];
  rrAlert?: AlertLog[];
  motionAlert?: AlertLog[];
  patientStatus?: PATIENT_STATUS;
};

export type MonitoringDaysData = {
  monitoredDaysCount: number;
  totalDays: number;
  patientId?: UUID;
  timeZone?: string;
  trend?: number;
};
export type ProcessedSleepData = {
  remSleep: number | null;
  ahi: number | null;
  sleep: number | null;
  startTime: string;
  startOfNight: number | null;
  endOfNight: number | null;
  apneaCount: number | null;
  failureReason: string | null;
};

export type SleepDataStore = Record<
  UUID,
  {
    apiStatus?: API_STATUS;
    data?: Record<string, ProcessedSleepData>;
  }
>;
export type BedOccupancyDataStore = Record<
  UUID,
  {
    apiStatus?: API_STATUS;
    hoursInBedData?: GraphTimeData[];
    numberOfBedExitAlertsData?: GraphTimeData[];
  }
>;
export type MotionDataStore = Record<
  UUID,
  {
    data?: Record<
      string,
      { highMotion: number; mediumMotion: number; lowMotion: number }
    >;
    apiStatus?: API_STATUS;
  }
>;
